
    import { defineComponent, ref, watch } from 'vue'

    import { useI18n } from 'vue-i18n-composable'
    import { useGtag } from '@/common/composables/libs/gtag'

    export default defineComponent({
        emits: {
            'volume-change': (value: unknown): boolean => {
                return Number.isFinite(value)
            }
        },
        setup (props, { emit }) {
            const gtag = useGtag()
            const i18n = useI18n()

            const lastVolume = ref(100)
            const muted = ref(false)
            const volume = ref(100)

            const mute = (): void => {
                if (muted.value) {
                    volume.value = lastVolume.value

                    gtag.event(i18n.t('analytics.player.unmute').toString(), {
                        event_category: 'Player'
                    })
                } else {
                    lastVolume.value = volume.value
                    volume.value = 0

                    gtag.event(i18n.t('analytics.player.mute').toString(), {
                        event_category: 'Player'
                    })
                }

                muted.value = !muted.value
            }

            const changeVolume = (value: number): void => {
                volume.value = value

                if (muted.value) {
                    muted.value = false
                    lastVolume.value = volume.value
                }

                gtag.event(i18n.t('analytics.player.volume').toString(), {
                    event_category: 'Player',
                    value: volume.value
                })
            }

            watch(volume, (): void => emit('volume-change', volume.value / 100))

            return {
                muted,
                volume,
                changeVolume,
                mute
            }
        }
    })
